import React from "react";
import styled from "styled-components";
import { PropLabel } from "../PropX";
import { style } from "../style";
import { CheckboxGroupStateProvider } from "./CheckboxStateContext";

const Fieldset = styled.fieldset`
  all: unset;

  width: 100%;
`;

const CheckboxGroupContainer = styled.div<{ $horizontal: boolean }>`
  all: unset;

  display: flex;
  align-items: flex-start;
  flex-wrap: wrap;
  flex-direction: ${(props) => (props.$horizontal ? "row" : "column")};
  column-gap: ${style.vars.whitespace.regular};
  row-gap: ${style.vars.whitespace.small};

  width: 100%;
`;

type Props = {
  label?: PropLabel;
  orientation?: "horizontal" | "vertical";
};

export const CheckboxGroup: React.FC<Props> = (props) => {
  const { children, orientation = "vertical" } = props;
  const horizontal = orientation === "horizontal";

  return (
    <Fieldset>
      {props.label && PropLabel.renderForBeforeInput(props.label, { as: "legend" })}
      <CheckboxGroupContainer $horizontal={horizontal}>
        <CheckboxGroupStateProvider horizontal={horizontal}>{children}</CheckboxGroupStateProvider>
      </CheckboxGroupContainer>
    </Fieldset>
  );
};

CheckboxGroup.displayName = "CheckboxGroup";
